import { ApiRoutes, QueryError } from '../../../common/interfaces';
import { apiExecutor, buildMutation, buildQuery } from '../../../common/services';
import { PageLayout } from '../entities';
import { PageLayoutsFormFields } from '../pageLayouts.interface';
import { PageLayoutsQueryKeys } from './pages.keys';

export const useGetByIdLayoutsPageQuery = (layoutId: string, siteId: string) =>
  buildQuery<PageLayout, QueryError>([PageLayoutsQueryKeys.GetOneById, siteId, layoutId], async () => {
    const { data } = await apiExecutor.get<PageLayout>(
      ApiRoutes.PageLayoutsById.replace(':siteId', siteId).replace(':layoutId', layoutId)
    );
    return data;
  });

export const useGetByIdLayoutsPageMutation = (siteId: string) =>
  buildMutation<PageLayout, QueryError, string>([PageLayoutsQueryKeys.GetOneById, siteId], async (pageLayoutId) => {
    const { data } = await apiExecutor.get<PageLayout>(
      ApiRoutes.PageLayoutsById.replace(':siteId', siteId).replace(':layoutId', pageLayoutId)
    );
    return data;
  });

export const useGetLayoutsPageQuery = (siteId: string) =>
  buildQuery<PageLayout[], QueryError>([PageLayoutsQueryKeys.GetAll, siteId], async () => {
    const { data } = await apiExecutor.get<PageLayout[]>(
      ApiRoutes.PageLayouts.replace(':siteId', siteId)
    );
    return data;
  });

export const useCreateLayoutsPageMutation = (siteId: string) =>
  buildMutation<PageLayout, QueryError, PageLayoutsFormFields>([PageLayoutsQueryKeys.Create, siteId], async (postData) => {
    const { data } = await apiExecutor.post<PageLayout>(ApiRoutes.PageLayouts.replace(':siteId', siteId), {
      ...postData, siteId
    });
    return data;
  });

export const useEditLayoutsPageMutation = (id: string, siteId: string) =>
  buildMutation<PageLayout, QueryError, PageLayoutsFormFields>([PageLayoutsQueryKeys.Edit, siteId, id], async (postData) => {
    const { data } = await apiExecutor.patch<PageLayout>(
      ApiRoutes.PageLayoutsById.replace(':siteId', siteId).replace(':layoutId', id),
      { ...postData, siteId, id }
    );
    return data;
  });

export const useDeleteLayoutsPageMutation = (id: string, siteId: string) =>
  buildMutation<void, QueryError, void>([PageLayoutsQueryKeys.Delete, siteId, id], async () => {
    await apiExecutor.delete<PageLayout>(
      ApiRoutes.PageLayoutsById.replace(':siteId', siteId).replace(':layoutId', id)
    );
  });

export const useBreadcrumbPageLayoutsQuery = (id: string, siteId: string) =>
  buildQuery<string, QueryError>([PageLayoutsQueryKeys.Breadcrumb, siteId, id], async () => {
    const { data } = await apiExecutor.get<string>(
      ApiRoutes.PageLayoutsBreadcrumb.replace(':siteId', siteId).replace(':layoutId', id)
    );
    return data;
  });

export const useAutocompletePageLayoutsQuery = (params: { query: string; includedIds?: string[]; }, siteId: string) =>
  buildQuery<
    Pick<PageLayout, 'id' | 'name'>[], QueryError
  >([PageLayoutsQueryKeys.Autocomplete, params], async () => {
    const { data } = await apiExecutor.get<Pick<PageLayout, 'id' | 'name'>[]>(ApiRoutes.PageLayoutsAutocomplete.replace(':siteId', siteId), {});
    return data;
  });
